<template>
  <span
    class="mr-10 pr-5 clickable"
    @click="clickAction"
  >
    {{ routeName=='Home'?'Login':'Home' }}
  </span>
</template>

<script>
  export default {
    name: 'AppHeaderLogin',

    computed: {
      routeName() {
        return this.$route.name
      },
      routeLink() {
        return this.routeName=='Home'?'/':'/home'
      }
    },

    mounted() {
      //
    },

    methods: {
      clickAction() {
        if (this.routeName == 'Home')
          this.$router.push({name: 'Login'})
        else
          this.$router.push({name: 'Home'})
      }
    }
  }
</script>